import { render, staticRenderFns } from "./UniversityAdd.vue?vue&type=template&id=21a59fdb"
import script from "./UniversityAdd.vue?vue&type=script&lang=js"
export * from "./UniversityAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UniversityAdd.vue?vue&type=style&index=1&id=21a59fdb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports